import Select from '@ben/orion/deprecated-select';
import { Controller, useFormContext, useWatch } from 'react-hook-form';
import styled, { css } from 'styled-components';
import { fieldCannotBeBlankErrorMessage } from '../../../shared/constants';
import {
  beneficiaryRelationshipOptions,
  beneficiaryTypesOptions,
} from '../_common/acceptedContactTypesOptions';

interface IModularBeneficiariesInputProps {
  componentControllerName: string;
}

const personBeneficiaryType = 'PERSON';

const ModularBeneficiariesInput = ({
  componentControllerName,
}: IModularBeneficiariesInputProps) => {
  const { control, setValue } = useFormContext();

  const beneficiaryTypes = useWatch({
    name: `${componentControllerName}.acceptedBeneficiaryTypes`,
    exact: true,
  }) as string[] | undefined;

  const isPersonAccepted =
    beneficiaryTypes?.includes(personBeneficiaryType) ?? false;

  return (
    <ComponentsWrapper>
      <Controller
        control={control}
        name={`${componentControllerName}.acceptedBeneficiaryTypes`}
        render={({ field, fieldState }) => (
          <Select
            {...field}
            name="Beneficiary types"
            options={beneficiaryTypesOptions}
            value={field.value ?? []}
            onChange={(value) => {
              const nextTypes = value ?? [];
              field.onChange(nextTypes);
              // Clear relationships only on a real deselection here in onChange
              // (never on mount, reset, or defaults re-sync, none of which call
              // this). shouldDirty so the section form's keepDirtyValues re-sync
              // can't restore the relationships we just cleared.
              if (!nextTypes.includes(personBeneficiaryType)) {
                setValue(
                  `${componentControllerName}.acceptedContactTypes`,
                  [],
                  {
                    shouldDirty: true,
                  }
                );
              }
            }}
            hasError={!!fieldState.error}
            errorMessage={fieldState.error?.message}
          />
        )}
        rules={{
          required: fieldCannotBeBlankErrorMessage,
        }}
      />
      {isPersonAccepted && (
        <Controller
          control={control}
          name={`${componentControllerName}.acceptedContactTypes`}
          render={({ field, fieldState }) => (
            <Select
              {...field}
              name="Accepted relationships"
              options={beneficiaryRelationshipOptions}
              value={field.value ?? []}
              onChange={(value) => field.onChange(value ?? [])}
              hasError={!!fieldState.error}
              errorMessage={fieldState.error?.message}
            />
          )}
          rules={{
            required: fieldCannotBeBlankErrorMessage,
          }}
        />
      )}
    </ComponentsWrapper>
  );
};

export default ModularBeneficiariesInput;

const ComponentsWrapper = styled.div`
  ${({ theme }) => css`
    width: 100%;
    display: flex;
    flex-direction: row;
    gap: ${theme.spacing(2)};
  `}
`;
